




































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */
import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class AssignSavedQuote extends Vue {
  @Prop({ default: false }) reassign!: boolean;
  protected closeModal(): void {
    this.$emit("close");
  }
}
